import api from "../client/axiosClient";

export const httpClient = {
  get: async <T>(url: string, config?: any): Promise<T> => {
    const response = await api.get<T>(url, config);
    return response.data;
  },

  post: async <T, B = unknown>(url: string, body?: B): Promise<T> => {
    const response = await api.post<T>(url, body);
    return response.data;
  },

  patch: async <T, B = unknown>(url: string, body?: B): Promise<T> => {
    const response = await api.patch<T>(url, body);
    return response.data;
  },

  delete: async <T>(url: string): Promise<T> => {
    const response = await api.delete<T>(url);
    return response.data;
  },
};
